
export const SOLACE_PUBLISH_EVENTS_SUCCESS = `SOLACE_PUBLISH_EVENTS_SUCCESS`

export const SOLACE_PUBLISH_EVENTS_FAILURE = `SOLACE_PUBLISH_EVENTS_FAILURE`

export const publishSolaceEventsSuccess = (payload:any): any => {
	return {
		type: SOLACE_PUBLISH_EVENTS_SUCCESS,
		payload
	}
}

export const publishSolaceEventsFailure = (payload:any): any => {
	return {
		type: SOLACE_PUBLISH_EVENTS_FAILURE,
		payload
	}
}